/** Night-off labels for planner day rows. Ids are API/DB enums; labels are UI copy. */

export const NIGHT_OFF_TYPES = Object.freeze([
  { id: 'takeout', label: 'Delivery' },
  { id: 'frozen', label: 'Heat & Eat' },
  { id: 'leftovers', label: 'Leftovers' },
  { id: 'out', label: 'Eat Out' },
])

/** Labels for picker types plus legacy ids still present on saved nights. */
const LABEL_BY_ID = Object.freeze({
  ...Object.fromEntries(NIGHT_OFF_TYPES.map((t) => [t.id, t.label])),
  pizza: 'Pizza',
})

export function isNightOffMeal(meal) {
  return Boolean(meal && meal.status === 'night_off')
}

export function nightOffLabel(typeId) {
  if (!typeId) return 'Night off'
  return LABEL_BY_ID[typeId] || 'Night off'
}

export function planItemIsAssigned(item) {
  if (!item) return false
  if (item.recipe_id) return true
  return item.status === 'night_off'
}

/**
 * Week-strip occupancy: cook nights (any recipe, including skipped/cooked),
 * night offs, and remaining open days.
 */
export function countWeekCoverage(assignedByDay) {
  let cook = 0
  let nightOff = 0
  const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']
  for (const day of days) {
    const meal = assignedByDay?.[day]
    if (isNightOffMeal(meal)) nightOff += 1
    else if (meal?.recipeId) cook += 1
  }
  return { cook, nightOff, open: days.length - cook - nightOff }
}

export function weekCoverageLabel({ cook = 0, nightOff = 0, open = 0 } = {}) {
  const off = nightOff === 1 ? '1 night off' : `${nightOff} nights off`
  return `${cook} cook · ${off} · ${open} open`
}
